import React, { useState } from "react";
import ButtonWithIcon from "../../commonComponent/ButtonWithIcon";
import { RiEdit2Fill } from "react-icons/ri";
import Popup from "../../commonComponent/Popup";
import DateInput from "../../commonComponent/CutomDatePicker";
import Button from "../../commonComponent/Button";

export default function UpdateCarePlanDetail({
  carePlanName,
  carePlanDescription,
  carePlanAssignedBy,
  postData,
  componentType,
  setCarePlanDescription,
  setCarePlanTitle,
  noLabel=false
}) {
  const [showPopup, setShowPopup] = useState(false);
  const [startDate, setStartDate] = useState("");

  const handleSubmitGoal = (e) => {
    e.preventDefault();
    postData({
      name: e.target.elements.title.value,
      description: e.target.elements.description.value,
    });
  };
  return (
    <section>
      <div>
        <ButtonWithIcon
          className="btn btn-light px-4 py-2"
          onClick={() => {
            setShowPopup(true);
          }}
          //   data-bs-toggle="modal"
          //   data-bs-target="#goalModal"
          // onClick={() => {
          //   setGoalApiChange("edit");
          //   setGoalId(goal._id);
          //   getSingleGoalById(goal._id);
          // }}
          icon={<RiEdit2Fill />}
          label={`${carePlanName === "" && carePlanDescription==="" ?"Add Care Plan Details": noLabel ? "" : "Edit Care Plan Details"}`}
        />
      </div>
      <Popup
        show={showPopup}
        onHide={() => setShowPopup(false)}
        title={`${componentType === "Add" ?"Add Care Plan Details":"Edit Care Plan Details"}`}
        content={
          <>
            <form onSubmit={handleSubmitGoal}>
              <div className="row">
                <div className="col-md-12">
                  <p className="whole_label resFont">
                    Care Plan Title
                    {/* <span style={{ color: "red", fontWeight: "bold" }}>*</span> */}
                  </p>
                  <input
                    name="title"
                    type="text"
                    className="description_inputf mb-4"
                    defaultValue={carePlanName}
                    // onChange={(e)=>setCarePlanTitle(e.target.value)}
                    // maxLength={80}
                    // onChange={(e) => {
                    //   setGoalName(e.target.value);
                    //   setError({ ...error, name: false });
                    // }}
                  />
                </div>

                <div className="col-md-12">
                  <p className="whole_label resFont">Description</p>
                  <textarea
                    type="text"
                    name="description"
                    className="description_inputf pt-3 mb-4"
                    style={{ height: "200px" }}
                    maxLength={200}
                    defaultValue={carePlanDescription}
                    // onChange={(e)=>setCarePlanDescription(e.target.value)}

                    // onChange={(e) => {
                    //   setDescription(e.target.value);
                    //   setError({ ...error, descr: false });
                    // }}
                  />
                  {/* {renderError("Please enter description", error.descr)} */}
                </div>
                <div className="col-md-12 ">
                  <p className="whole_label resFont ">
                    Assign
                    <span className="small_letter2 ml-2">{" " }By</span>{" "}
                    {/* <span style={{ color: "red", fontWeight: "bold" }}>*</span> */}
                  </p>
                  <p
                    className="description_inputf  d-flex  align-items-center"
                    defaultValue={carePlanAssignedBy}
                    style={{
                      color: "#bbb9b9",
                    }}
                    // maxLength={80}
                    // onChange={(e) => {
                    //   setGoalName(e.target.value);
                    //   setError({ ...error, name: false });
                    // }}
                  > {carePlanAssignedBy}</p>
                </div>
              </div>

              <div className="col-md-12">
                <hr />
                <div className="d-flex justify-content-between">
                  <div
                    style={{
                      backgroundColor: "#fff",
                      color: "black",
                      border: "1px solid #bbb9b9",
                    }}
                    onClick={() => {
                      setShowPopup(false);
                    }}
                    className="description_btnsave pointer d-flex justify-content-center align-items-center"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    Cancel
                  </div>
                  <Button
                    //   isLoading={isSubmit}
                    //   disabled={isSubmit}
                      onClick={() => {
                        setShowPopup(false);
                      }}
                    text="Save"
                    type="submit"
                    id="reateProgram"
                    className="description_btnsave d-flex justify-content-center align-items-center pointer"
                  >
                    Save
                  </Button>
                </div>
              </div>
            </form>
          </>
        }
        position="top"
        // btn1="Save"
        // btn2="Cancel"
      />
    </section>
  );
}
